import api from "../../../../api"

function getActiveStepFromStorage(self)
{
    const active_step_from_storage = api.storage.get(self, `cost_evaluation_${self.group_id}`, null, Object)
    
    if (active_step_from_storage) {
        return [
            active_step_from_storage.active_step,
            active_step_from_storage.profitable,
            active_step_from_storage?.active_step.split("_")[0]
        ]
    }
    else
    {
        return [undefined, undefined, undefined]
    }
}

function getActiveStepFromType(type, steps)
{
    let step = steps.find((step) => type === step.id)

    if (!step) {
        step = steps[0]
    }

    if (step.children) {
        return step.children[0].id
    }
    else
    {
        return step.id
    }
}

function checkProfitable(capitalization, active_step, capitalization_from_storage)
{
    const check_profitable_values = {
        "profitable_step1_1_1_2" : ["net_operating_income.actual_gross_income.potential_gross_income.type"],
        "profitable_step1_1_1_3" : [
            "net_operating_income.actual_gross_income.potential_gross_income.type",
            "net_operating_income.actual_gross_income.potential_gross_income.analogues.with_season_factors"
        ],
        "profitable_step2_1" : ["capitalization_rate.type"],
        "profitable_step2_2" : ["capitalization_rate.type"]
    }

    const checkFields = check_profitable_values[active_step]

    if (checkFields)
    {
        for (let field of checkFields)
        {
            const result = api.get_obj_value(capitalization, field) === api.get_obj_value(capitalization_from_storage, field)

            if (!result) { return false }
        }
    }

    return true
}

function getProfitableActiveStep(capitalization, active_step, capitalization_from_storage)
{
    if (checkProfitable(capitalization, active_step, capitalization_from_storage))
    {
        return active_step
    }
    else
    {
        const path = active_step.split("_")

        if (path.length > 1)
        {
            return path.slice(0, -1).join("_")
        }
        else
        {
            return path[0]
        }
    }
}

function getReferenceActiveStep(reference, active_step)
{
    if (active_step != "reference_step2_1" || reference.calc_type == "Метод сравнения продаж")
    {
        return active_step
    }
    else
    {
        return "reference_step2"
    }
}

function findStepOrParentById(steps, step_id)
{
    function _findStepById(steps)
    {
        const step_index = steps.findIndex(e => step_id.startsWith(e.id))

        if (step_index != -1)
        {	
            if (steps[step_index].id === step_id)
            {
                return steps[step_index].id
            }
            else if(!step_id.match(new RegExp(`${steps[step_index].id}_\\d$`) && steps[step_index].children))
            {
                return _findStepById(steps[step_index].children)
            }
        }
    }
    
    return _findStepById(steps)
}

// Sources:
// 1. CE_data / steps
// 2. URL
// 3. LocalStorage

export default function(self, steps)
{
    try {
        const params_type = self.$route.params.type

        const [active_step_from_storage, profitable_from_storage, type_from_storage] = getActiveStepFromStorage(self)

        const step = steps.find((step) => step.id === type_from_storage)

        if ((params_type === undefined || params_type === type_from_storage) && step)
        {
            if (type_from_storage == 'individual')
            {
                return active_step_from_storage
            }

            const step_id = findStepOrParentById(steps, active_step_from_storage)

            if (step_id)
            {
                if (type_from_storage === "profitable")
                {
                    const result = getProfitableActiveStep(
                        self.group.cost_evaluation_profitable.capitalization,
                        active_step_from_storage,
                        profitable_from_storage.cost_evaluation.capitalization
                    )

                    return result
                }
                else
                {
                    return step_id
                }
                
            }
            else if (type_from_storage === "reference")
            {
                return getReferenceActiveStep(self.group.cost_evaluation_comparative.reference, active_step_from_storage)
            }
            else
            {
                return getActiveStepFromType(type_from_storage, steps)
            }
        }
        else
        {
            return getActiveStepFromType(params_type, steps)
        }   
    }
    catch (error)
    {
        console.error(error)
        return getActiveStepFromType(undefined, steps)
    }
}
